import { useEffect, type ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PulseBackground } from './components/Brand.js';
import { ConnectionBanner, Toasts } from './components/Toasts.js';
import { HomePage } from './routes/HomePage.js';
import { CreatePage } from './routes/CreatePage.js';
import { JoinPage } from './routes/JoinPage.js';
import { RoomPage } from './routes/RoomPage.js';
import { HowToPlayPage } from './routes/HowToPlayPage.js';
import { useGameStore } from './store/gameStore.js';
import { useI18n } from './i18n/index.js';

type ServerConfig = { appName: string; version: string; publicAppUrl: string };

export function App(): ReactNode {
  const setPublicAppUrl = useGameStore((state) => state.setPublicAppUrl);
  const { locale } = useI18n();

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  useEffect(() => {
    let active = true;
    fetch('/api/config')
      .then((response) => (response.ok ? (response.json() as Promise<ServerConfig>) : null))
      .then((config) => {
        if (active && config?.publicAppUrl) setPublicAppUrl(config.publicAppUrl);
      })
      .catch(() => {
        // Sem /api/config seguimos usando a origem do navegador.
      });
    return () => {
      active = false;
    };
  }, [setPublicAppUrl]);

  return (
    <>
      <PulseBackground />
      <ConnectionBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/criar" element={<CreatePage />} />
        <Route path="/entrar" element={<JoinPage />} />
        <Route path="/sala/:codigo" element={<RoomPage />} />
        <Route path="/como-jogar" element={<HowToPlayPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toasts />
    </>
  );
}
